import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Modal,
  Button,
  Form,
  Image,
  Badge,
} from "react-bootstrap";

const CoreServices = ({ initialData, onUpdate }) => {
  const [showModal, setShowModal] = useState(false);
  const [services, setServices] = useState(
    Array.isArray(initialData) ? initialData : []
  );
  const [tempServices, setTempServices] = useState([...services]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setServices(Array.isArray(initialData) ? initialData : []);
  }, [initialData]);

  // Open and close modal
  const handleShow = () => {
    setTempServices([...services]); // Reset temp data before editing
    setShowModal(true);
  };
  const handleClose = () => setShowModal(false);

  // Handle keypress to add services
  const handleKeyDown = (event) => {
    if (event.key === "Enter" && inputValue.trim()) {
      event.preventDefault();
      setTempServices([...tempServices, inputValue.trim()]);
      setInputValue("");
    } else if (event.key === "Backspace" && inputValue === "") {
      // Remove last service when backspace is pressed in empty input
      setTempServices(tempServices.slice(0, -1));
    }
  };

  // Save changes from modal to card
  const handleSave = () => {
    // setServices([...tempServices]);
    setShowModal(false);
    onUpdate([...tempServices]);
  };
  return (
    <Row className="px-4 body-font">
      <Col>
        <Card className="business_details_border">
          <Card.Header className="px-4 body-font fw-bold fs-two d-flex justify-content-between business_info_card_header">
            <div className="d-flex black-color" style={{ gap: "12px" }}>
              <Image
                src="/assets/material-symbols_business-center-outline.svg"
                alt="Core Services"
              />
              Core Services
            </div>
            <div
              className="d-flex gap-1 align-items-center cursor-pointer"
              onClick={handleShow}
              style={{ cursor: "pointer" }}
            >
              <Image
                src="/assets/edit-1.svg"
                alt="Edit"
                className="business-info-icon"
              />
              <span className="fs-four" style={{ color: "#5925DC" }}>
                Edit
              </span>
            </div>
          </Card.Header>

          <Card.Body className="p-4 d-flex flex-row flex-wrap gap-2">
            {services.length > 0 ? (
              services.map((service, index) => (
                <Badge
                  key={index}
                  pill
                  bg="light"
                  text="dark"
                  className="mb-2 px-3 py-2 core_services_badge text-truncate"
                  style={{ maxWidth: "100%" }}
                >
                  {service}
                </Badge>
              ))
            ) : (
              <p className="text-muted">No services added yet.</p>
            )}
          </Card.Body>
        </Card>
      </Col>

      {/* Modal Component */}
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header
          closeButton
          className="business-hrs-border-bottom"
          style={{ backgroundColor: "#FAFAFA" }}
        >
          <Modal.Title className="fw-medium black-color fs-five">
            Core Services
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="direction-modal-body">
          <p className="mb-1 fs-four" style={{ color: "#414651" }}>
            Type and hit “Enter” to add new services.
          </p>
          <div
            style={{
              borderColor: "#D5D7DA",
              padding: "10px 14px",
              marginBottom: "1rem",
            }}
            className="border  rounded d-flex flex-wrap align-items-center gap-2"
          >
            {tempServices.map((service, index) => (
              <Badge
                key={index}
                pill
                bg="light"
                text="dark"
                className="px-3 py-2 fw-medium fs-four core_services_badge text-truncate"
                style={{ marginBottom: "7px" }}
              >
                {service}
              </Badge>
            ))}
            <Form.Control
              type="text"
              placeholder="Add a service..."
              className="border-0 shadow-none"
              style={{ outline: "none", width: "auto", flexGrow: 1 }}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="gap-4 business-info-modal-footer">
          <span className="gray-color fs-four m-0">
            Changes will go live immediately
          </span>
          <div className="gap-3 m-0 d-flex">
            <Button
              className="m-0 direction-modal-button fw-bold fs-four border-0 direction-modal-cancel"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className="direction-modal-button m-0 btn-primary-style fw-bold px-3 fs-four"
              style={{ color: "#ffffff" }}
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </Row>
  );
};

export default CoreServices;
